import { type Session } from 'next-auth';

import { getNotificationsApiHeaders } from '@module/mdrt-org/shared/utils/helpers/get-headers';
import { mutateWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/mutate-with-error-handling';

export const postUserNotificationStatusUpdate = async ({
  accessToken,
  notificationId,
  personId,
}: {
  accessToken: string | undefined;
  notificationId: string;
  personId: number | undefined;
  session?: null | Session;
}) => {
  if (!(accessToken && personId)) {
    throw new Error('Access token or person ID is not available');
  }

  return await mutateWithErrorHandling(
    `${window.PUBLIC_ENV.apiBaseUrl}/${
      window.PUBLIC_ENV.notificationsApiRoute ?? 'notifications-api'
    }/Notifications/Users/${personId}/Read/${notificationId}`,
    {
      headers: {
        ...getNotificationsApiHeaders(accessToken),
      },
      method: 'POST',
    }
  );
};
